import { render, staticRenderFns } from "./UpdateVipTimeForm.vue?vue&type=template&id=520efac8&scoped=true"
import script from "./UpdateVipTimeForm.vue?vue&type=script&lang=js"
export * from "./UpdateVipTimeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520efac8",
  null
  
)

export default component.exports